import { List, fromJS } from 'immutable';

export function receive(state, { chatId, message }) {
    let messages = state.getIn([ 'items', chatId, 'messages' ], List()).push(fromJS(message));

    return state
        .setIn([ 'items', chatId, 'messages' ], messages);
}
